import { request } from "../../apis";

export const apiGetProductCountryList = (params: any): any =>
  request("get", `/api/product/search`, params, false);

export const apiGetProductItemDetail = (params: any): any =>
  request("get", `/api/product/item/${params.product_id}`, null, false);

export const apiGetProductMethods = (params: any): any =>
  request("get", `/api/product/method`, params, false);

export const apiGetProductDays = (params: any): any =>
  request("get", `/api/product/method/days`, params, false);

export const apiGetSeoList = (params: any): any =>
  request(
    "get",
    `/api/seo/list?code=${params.code}&page=${params.page}`,
    null,
    false
  );
